import store from '../store';

/**
 * returns the first permission obect in either userPermissions OR companyPermissions array having an granted property equal to 1
 * @param {string} permission permission name to search for
 * @param {array} arrPermissions optional: default is to check company and user level permissions
 * @returns truthy or falsy indicating if user has specified permission
 */
export function hasPermission(permission, arrPermissions) {
    // debugger;// eslint-disable-line no-debugger
    if (!arrPermissions) {
        var u = hasPermission(permission, store.getters.userPermissions);
        var c = hasPermission(permission, store.getters.companyPermissions);
        if (typeof c === 'undefined') {
            return u; // if not a company permission, return state of user level permission
        }
        if (!c) {
            return false; // not at company level, user does not get it
        }
        if (typeof u === 'undefined') {
            return true; // GRANT -- since granted at COMPANY level (c) and undefined at USER level (u)
        }
        return u; // return user setting
    }
    // return value from specific permissions array
    permission = permission.toUpperCase();
    let i;
    for (i = 0; i < arrPermissions.length; i++) {
        if (permission === arrPermissions[i].permission) {
            return arrPermissions[i].granted === '1';
        }
    }
    return undefined;
}

export function hasPermissionToRoute(route) {
    if(!route.meta.permissions?.length) {
        return true;
    }
    let userHasPermission = false;
    for(let permission of route.meta.permissions) {
        userHasPermission = hasPermission(permission);
        if(!userHasPermission) {
            break;
        }
    }
    return userHasPermission;
}
export function hasPermissionToNavItem(navItem) {
    if(!navItem.permissions?.length) {
        return true;
    }
    let userHasPermission = false;
    for(let permission of navItem.permissions) {
        userHasPermission = hasPermission(permission);
        if(!userHasPermission) {
            break;
        }
    }
    return userHasPermission;
}